import client from "../utils/ApiHelper.js";
import ErrorException from "../utils/Exceptions.js";

async function fetchAllInbound(date) {
  try {
    let res = await client.get(`/inbound?date_scan=${date}`);

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function fetchOneInbound(id) {
  try {
    let res = await client.get("/inbound/inbound_id/" + id);

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function fetchInboundByRFID(rfid_number) {
  try {
    let res = await client.get(`/inbound/inbound?rfid_number=${rfid_number}`);

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function createInbound(
  rfid,
  part,
  qr_sap,
  production_date,
  qty,
  batch,
  shift,
  tracking,
  rack_id
) {
  try {
    let res = await client.post("/inbound/create", {
      rfid_number: rfid,
      part: part,
      qr_sap: qr_sap,
      production_date: production_date,
      qty: qty,
      batch: batch,
      shift: shift,
      tracking: tracking,
      rack_id: rack_id,
    });

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function checkRFID(rfid_number) {
  try {
    let res = await client.get(
      `/inbound/check-rfid?rfid_number=${rfid_number}`
    );

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function deleteInbound(id) {
  try {
    let res = await client.delete("/inbound/inbound_id/" + id);

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

export {
  fetchAllInbound,
  fetchOneInbound,
  fetchInboundByRFID,
  createInbound,
  checkRFID,
  deleteInbound,
};
